import * as $ from "jquery";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
// bao migrate - module not found: import Finito from "modules/finito-module";
import BaoMenu from "./../../services/bao-menu";
import TabPage from "./../../factories/tab-page";
import finitoService from "./../../services/finito-service";
import BaoDialog from "./../../factories/bao-dialog";
import Guid from "./../../factories/guid";
import SubscriptionViewModel from "./../../factories/subscription-view-model";
import baoRouter from "./../../services/bao-router";
import "./../../bindings/bao-toolbar2";
function ShiftReportEvaluationTab(tabPage, parent) {
    var self = this;
    SubscriptionViewModel.call(this, tabPage);
    self.Bao = Bao;
    self.ReportViewModel = parent;
    self.CompleteCheck = function () {
        return true;
    };
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.RefreshGrid();
    });
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function () {
        self.RefreshGrid();
    });
    self.EvaluationCollection = ko.observableArray([]);
    self.SelectRow = function (item) {
        self.SelectedEvaluationRow(item);
        return true;
    };
    self.SelectedEvaluationRow = ko.observable({});
    self.SelectedEvaluationRow.subscribe(function () {
        if (self.SelectedEvaluationRow() == null) {
            self.enableDisableButton("EditReportEvaluation", false);
            self.enableDisableButton("DeleteReportEvaluation", false);
        }
        else {
            self.enableDisableButton("EditReportEvaluation", true);
            self.enableDisableButton("DeleteReportEvaluation", Bao.Utils.String.IsNullOrWhitespace(self.SelectedEvaluationRow().CompleteDateJs));
        }
    });
    var _deleteMessage = Bao.Session.GetMessage("msgDeleteReportEvaluation");
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "AddReportEvaluation":
                self.ShowCreateEvaluationDialog(self.ReportViewModel.ReportId());
                break;
            case "EditReportEvaluation":
                if (self.SelectedEvaluationRow() != null) {
                    self.EditReportEvaluation(self.SelectedEvaluationRow());
                }
                break;
            case "DeleteReportEvaluation":
                var yesNoDialog = new BaoDialog(Bao.Session.ApplicationName, _deleteMessage, "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result === true) {
                        self.DeleteReportEvaluation(self.SelectedEvaluationRow());
                    }
                });
                break;
            case "RefreshReportEvaluation":
                self.RefreshGrid();
                break;
        }
    };
    self.RefreshGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("EvaluationTab/GetEvaluationCollection", JSON.stringify({
            reportId: self.ReportViewModel.ReportId(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedEvaluationRow(null);
            self.TotalRows(0);
            self.EvaluationCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.EvaluationCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
        });
    };
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    self.CreateEvaluation = function (folderStructureChecklistId, reportId) {
        tabPage.IsLoading(true);
        return Bao.post("EvaluationTab/CreateEvaluationByReport", JSON.stringify({
            folderStructureChecklistId: folderStructureChecklistId,
            reportId: reportId
        }), function (result) {
            if (result != false) {
                baoRouter.setHash("checkware/evaluation/" + result);
            }
            tabPage.IsLoading(false);
        });
    };
    self.DeleteReportEvaluation = function (item) {
        Bao.post("EvaluationTab/DeleteEvaluation", JSON.stringify({
            evaluationId: ko.unwrap(item.EvaluationId)
        }), function () {
            self.RefreshGrid();
        });
    };
    self.EditReportEvaluation = function (item) {
        baoRouter.setHash("checkware/evaluation/" + ko.unwrap(item.EvaluationId));
    };
    self.ShowCreateEvaluationDialog = function (reportId) {
        window.baorequire(["ViewModels/Dialogs/CreateEvaluationDialog"], function (vm) {
            var dialog = new vm(tabPage, self);
            dialog.Show();
            dialog.DialogResult.subscribe(function (dialogResult) {
                if (dialogResult == true) {
                    self.CreateEvaluation(dialog.DialogViewModel.FolderStructureChecklistId(), self.ReportViewModel.ReportId());
                }
            });
        });
    };
    self.enableDisableButton = function (actionKey, enabled) { };
    self.Refresh = function () {
        return self.RefreshGrid();
    };
    self.Save = function () { };
    self.loaded = function () {
        return $.when(self.Refresh()).then(function () {
            self.subscribe(self.PageSize, function () {
                if (self.PageIndex() === 0) {
                    self.RefreshGrid();
                }
                else {
                    self.PageIndex(0);
                }
            });
        });
    };
    self.canClose = function () {
        var def = $.Deferred();
        def.resolve(true);
        return def.promise();
    };
}
;
Bao.inherit(ShiftReportEvaluationTab, SubscriptionViewModel);
export default ShiftReportEvaluationTab;